// transport-mode.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { ApiheaderService } from './apiheader.service';
import { URLPaths } from '../utilities/urlPaths.config';


@Injectable({
  providedIn: 'root',
})
export class TransportModeService {
  private modeMap: { [desc: string]: number } = {};
  private idToDescMap: { [id: number]: string } = {};
  private apiUrl = URLPaths.URL_TRANSPORT_MODES;
  private transportModes$: Observable<any[]> | null = null;

  constructor(private http: HttpClient) {}

  getTransportModes(): Observable<any[]> {
    if (!this.transportModes$) {
      this.transportModes$ = this.http.get<any[]>(this.apiUrl, { headers: ApiheaderService.getHeaders() }).pipe(
        tap((modes) => this.setMap(modes)),
        shareReplay(1)
      );
    }
    return this.transportModes$;
  }
  fetchModes() {
    return this.http.get<any[]>(this.apiUrl);
  }

  setMap(modes: any[]) {
    modes.forEach((m) => {
      this.modeMap[m.transportmode_desc] = m.transportmode_id;
      this.idToDescMap[m.transportmode_id] = m.transportmode_desc;
    });
  }

  getIdByName(name: string): number {
    return this.modeMap[name] || 0;
  }
  getNameById(id: number): string {
    return this.idToDescMap[id] || `Mode ${id}`;
  }
}
